import {useCallback, useEffect, useState} from 'react'
import {Lang} from 'yougile-lang'
import {Util} from 'yougile-util'
import {Hub} from 'yougile-model'
import {PermissionsChecker} from '@client/permissions-checker'
import {Storage} from '@client/storage'
import {Sync} from '@client/sync'
import {globals} from '@extensions/globals-base'
import {Project} from '@extensions/project'

export type BannerType = 'trello' | 'extensions' | 'none'

export const useBannerType = (): [BannerType, () => void] => {
  const [type, setType] = useState<BannerType>('none')

  const invalidate = useCallback(() => {
    setType('none')
  }, [])

  useEffect(() => {
    if (Util.isDesktop() || globals.standalone) {return}

    const createdAt = Sync.getCurrentUser()?.timestamp
    if (!createdAt) {return}

    const daysSince = Math.floor(
      (Date.now() - createdAt) / (1000 * 60 * 60 * 24)
    )

    const trelloClosed = Storage.getItem('banner-import-from-trello') === '0'
    const extensionsClosed =
      Storage.getItem('banner-go-to-extensions') === 'closed'

    const companyId = globals.getCompanyId()
    const box = Sync.getCurrentSandbox()
    const company = box?.get(companyId) as Hub

    const canAddProjects = PermissionsChecker.checkAddChildTo(company)

    const titles = [
      Lang.getMessages('en').reg.exampleProject,
      Lang.getMessages('ru').reg.exampleProject
    ]

    const hasExampleProject = Project.listProjects(
      companyId,
      'not-archive',
      true
    ).some(p => titles.includes(p.title) && !p.deleted)

    const showTrello =
      daysSince <= 9 && !trelloClosed && canAddProjects && hasExampleProject

    if (showTrello) {
      setType('trello')
    } else if (!extensionsClosed) {
      setType('extensions')
    } else {
      setType('none')
    }
  }, [type])

  return [type, invalidate]
}
